import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { UpdateSeasonPoolModel } from "~pages/SeasonPools/types/seasonPoolModel.ts";
import type { PoolResponse } from "~types/pool.ts";

export const useUpdateSeasonPool = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<PoolResponse, Error, UpdateSeasonPoolModel>({
    mutationFn: async ({ poolCode, ...updateData }) =>
      await request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools/${poolCode}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async (_, variables) => {
      notification.success({
        message: formatMessage({ id: "pool.update.success" }),
        placement: "bottomRight",
      });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["seasonPools", sport, organizationId, seasonId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonPool", sport, organizationId, seasonId, variables.poolCode] }),
      ]);
    },
  });
};
